import { graphql } from "gatsby";
import { ModalsBasic, ModalsLiveExample, ModalsOptionalSizes } from "../../../../src/examples/components/Modals";
import * as React from 'react';
export default {
  graphql,
  ModalsBasic,
  ModalsLiveExample,
  ModalsOptionalSizes,
  React
};